module.exports = __webpack_public_path__ + "img/image2.f8841379.png";